/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./themeDomains.vue?vue&type=template&id=8d7d611c&scoped=true"
import script from "./themeDomains.vue?vue&type=script&lang=js"
export * from "./themeDomains.vue?vue&type=script&lang=js"
import style0 from "./themeDomains.vue?vue&type=style&index=0&id=8d7d611c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7d611c",
  null
  
)

export default component.exports